import { ApolloError, ServerError } from '@apollo/client';

export const getApolloError = (error?: ApolloError) => {
  if (!error) return undefined;

  const serverError = error.networkError as ServerError | null;

  return (
    serverError?.result?.errors?.[0]?.message ||
    error.graphQLErrors?.[0]?.message ||
    error.message
  );
};
